import React from "react";
import { graphql, compose, withApollo } from "react-apollo";
import { withRouter } from "react-router";
import _ from "lodash";
import I18n from "../../I18n/I18n";
import {
  childTerms,
  currentUserCart,
  currentUserQuery,
  currencyById,
  createNodeCartLineItem,
  createNodeCartLineItemWithSizes,
  productSearch,
  productCategories,
  getQuantitiesByRegion,
} from "../../queries";
import { ADD_ELEMENT } from "../../utils/constants";
import { getTotalByRegion } from "../../utils";
import axios from "axios";
import {
  ProductCard,
  Panel,
  DropDown,
  FilterList,
  Message,
  PackageCard,
  ResponsivePagination,
  Spinner,
  SearchResult,
} from "dab-component-lib";

import {
  GridContainerStyle,
  LoadingStyle,
  ErrorStyle,
} from "../../utils/style-utils";
import {
  ListRowStyle,
  ListColStyle,
  CardContainer,
  DropdownContainerStyle,
  FilterWrapperStyle,
  SearchResultTextStyle,
} from "./style";

class SearchResultPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      products: [],
      productsFiltered: [],
      addCartSuccess: false,
      purchased: false,
      error: false,
      errorId: "",
      loading: true,
      errorQuantity: false,
      currentPage: 1,
      count: 0,
      originalCount: 0,
      offset: 0,
      errorIdQuantity: "",
      quantitiesByRegion: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      productSearch: { productSearchGraphql1View },
    } = nextProps;
    if (productSearchGraphql1View) {
      this.setState({
        productsFiltered: productSearchGraphql1View.results,
        products: productSearchGraphql1View.results,
        count: productSearchGraphql1View.count,
        originalCount: productSearchGraphql1View.count,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { productSearch } = this.props;
    if (
      prevProps.productSearch !== productSearch &&
      productSearch.productSearchGraphql1View
    ) {
      let quantitiesByRegion = [];
      let count = productSearch.productSearchGraphql1View.count;
      productSearch.productSearchGraphql1View.results.forEach(
        async (result) => {
          const { data } = await this.props.client.query({
            query: getQuantitiesByRegion,
            variables: {
              field_product_category_target_id: null,
              id: {
                value: result.entityId,
              },
              name: localStorage.getItem("userRegion")
                ? localStorage.getItem("userRegion")
                : "ITALY",
            },
          });
          quantitiesByRegion = quantitiesByRegion.concat(
            data.filteredProductsGraphqlAmountxRegionView.results
          );
          count -= 1;
          if (count === 0) {
            this.setState({
              quantitiesByRegion,
              loading: false,
            });
          }
        }
      );
    }
  }

  createNodeCartLineItem = async (targetIdProduct, quantity, size) => {
    const { createNodeCartLineItem, createNodeCartLineItemWithSizes } =
      this.props;
    let result = [];
    if (size) {
      result = await createNodeCartLineItemWithSizes({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
          size,
        },
      });
    } else {
      result = await createNodeCartLineItem({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
        },
      });
    }
    return result;
  };

  handleAddToCart = async ({ id, settings: { quantity, size } }) => {
    const { currentUserCart, currencyById } = this.props;
    const { products } = this.state;
    this.setState({
      loading: true,
      error: false,
      errorId: "",
      errorQuantity: false,
    });
    let product = _.find(products, (product) => product.entityId === id);
    if (!product) {
      product = _.find(
        this.state.products,
        (product) => product.fieldCode === id
      );
    }
    const { fieldAvailability, fieldMaxShopQuantity, entityId } = product;
    if (quantity <= fieldAvailability && quantity <= fieldMaxShopQuantity) {
      let nidObject = await this.createNodeCartLineItem(
        entityId,
        quantity,
        size
      );
      let nid = nidObject.data.createNodeCartLineItem.entity.nid;
      let currencyName = currencyById.nodeById.fieldCurrencyName;
      let uid = localStorage.getItem("currentUid");
      let res = {};
      if (
        !currentUserCart.error &&
        !currentUserCart.loading &&
        currentUserCart.currentusercartGraphql1View.results.length < 1
      ) {
        res = await axios.get(
          `${ADD_ELEMENT}/create/${nid}/${currencyName}/${uid}`
        );
      } else {
        let cartId = currentUserCart.currentusercartGraphql1View.results[0].id;
        res = await axios.get(
          `${ADD_ELEMENT}/${cartId}/${nid}/${currencyName}/${uid}`
        );
      }
      if (res.data.status === 1) {
        await currentUserCart.refetch();
        await this.setState({ loading: false, purchased: true });
      } else {
        await this.setState({ loading: false, error: true, errorId: id });
      }
    } else {
      this.setState({
        loading: false,
        errorIdQuantity: id,
        errorQuantity: true,
      });
    }
  };

  filter = (filters) => {
    this.setState({ currentPage: 1, offset: 0 });
    const { products, originalCount } = this.state;
    let oldProducts = products.slice();
    let filtersTrue = filters.filter((fil) => {
      return fil.checked;
    });
    if (filtersTrue.length === 0) {
      this.setState({
        productsFiltered: products,
        count: originalCount,
      });
    } else {
      let newProducts = [];
      filtersTrue.forEach((filter) => {
        let filtered = oldProducts.filter((product) => {
          return product.fieldProductCategory[0].targetId === filter.tid;
        });
        filtered.forEach((filt) => {
          newProducts.push(filt);
        });
      });
      this.setState({
        productsFiltered: newProducts,
        count: newProducts.length,
      });
    }
  };

  handleGoToDetail = (id) => {
    const { history } = this.props;
    history.push(`/product-detail/${id}`);
  };

  orderBy = (property, isArray) => {
    let newArray = this.state.products.slice();
    let sorted = newArray.sort((a, b) => {
      if (isArray) {
        return a[property][0]["targetId"] > b[property][0]["targetId"]
          ? 1
          : b[property][0]["targetId"] > a[property][0]["targetId"]
          ? -1
          : 0;
      }
      return a[property] > b[property] ? 1 : b[property] > a[property] ? -1 : 0;
    });
    this.setState({ productsFiltered: sorted, products: sorted });
  };

  fetchMoreProducts = (numPage) => {
    this.setState({ currentPage: numPage, offset: (numPage - 1) * 10 });
  };

  openPdf = (pdfUrl) => {
    window.open(pdfUrl, "__blank");
  };

  showAvailability = () => {
    const { currentUserQuery } = this.props;
    if (!currentUserQuery.loading && !currentUserQuery.error) {
      let role = _.find(
        currentUserQuery.currentUserContext.roles,
        (role) =>
          //role.targetId === "visitor_filial" ||
          role.targetId === "visitor_customer"
      );
      if (role) {
        return false;
      }
      return true;
    }
  };

  errorHandler() {
    if (this.state.errorQuantity) {
      return (
        <div>
          <Message
            description={I18n.t("errors.quantityPurchaseErrorDescription")}
            title={I18n.t("errors.quantityPurchaseError")}
          />
        </div>
      );
    }
    return (
      <div>
        <Message
          description={I18n.t("errors.purchaseErrorDescription")}
          title={I18n.t("errors.purchaseError")}
        />
      </div>
    );
  }

  render() {
    const {
      productSearch,
      childTerms,
      currencyById,
      currentUserQuery,
      productCategories,
    } = this.props;
    const {
      productsFiltered,
      offset,
      error,
      errorId,
      errorIdQuantity,
      errorQuantity,
      count,
      currentPage,
      loading,
      quantitiesByRegion,
    } = this.state;
    const ITEMS_PER_PAGE = 10;
    let filters = [];
    if (!productCategories.loading && !productCategories.error) {
      productCategories.feNavigationMenuTermsGraphql1View.results.forEach(
        (category) => {
          if (
            category.name !== "Documentation" &&
            category.name !== "Documentazione"
          ) {
            filters.push({
              checked: false,
              label: category.name,
              tid: category.tid,
            });
          }
        }
      );
    }
    if (!childTerms.loading && !childTerms.error) {
      childTerms.childtermsGraphql1View.results.forEach((term) => {
        filters.push({
          checked: false,
          label: `${I18n.t("content.documentation")} - ${term.name}`,
          tid: term.tid,
        });
      });
    }

    if (loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }

    return (
      <GridContainerStyle>
        {(productSearch.loading ||
          childTerms.loading ||
          productCategories.loading ||
          currentUserQuery.loading) && (
          <LoadingStyle>
            <Spinner size={150} />
          </LoadingStyle>
        )}
        {(productSearch.error ||
          childTerms.error ||
          productCategories.error ||
          currentUserQuery.error) && (
          <ErrorStyle>
            <h3>{I18n.t("errors.listError")}</h3>
          </ErrorStyle>
        )}
        {!productSearch.loading &&
          !productSearch.error &&
          !childTerms.error &&
          !childTerms.loading &&
          !productCategories.loading &&
          !productCategories.error && (
            <div>
              <SearchResultTextStyle>
                <SearchResult
                  count={count}
                  lang={
                    localStorage.getItem("language")
                      ? localStorage.getItem("language")
                      : "it"
                  }
                />
              </SearchResultTextStyle>
              <ListRowStyle>
                <ListColStyle quarter>
                  {!childTerms.error &&
                    !childTerms.loading &&
                    !productCategories.loading &&
                    !productCategories.error &&
                    childTerms.childtermsGraphql1View.results.length > 0 && (
                      <FilterWrapperStyle>
                        <Panel title={I18n.t("content.filterType")}>
                          <FilterList
                            onChange={({ options }) => this.filter(options)}
                            options={filters}
                          />
                        </Panel>
                      </FilterWrapperStyle>
                    )}
                </ListColStyle>
                <ListColStyle>
                  {productsFiltered.length > 0 ? (
                    <div>
                      <DropdownContainerStyle>
                        <DropDown
                          disabled={false}
                          expanded={false}
                          id="order-dropdown"
                          onChange={({ value }) =>
                            this.orderBy(
                              value,
                              value === "fieldProductCategory"
                            )
                          }
                          options={[
                            {
                              label: I18n.t("content.orderName"),
                              value: "name",
                            },
                            {
                              label: I18n.t("content.orderDate"),
                              value: "fieldLastModifiedDate",
                            },
                            {
                              label: I18n.t("content.orderByType"),
                              value: "fieldProductCategory",
                            },
                          ]}
                          placeholder={I18n.t("content.orderBy")}
                          selectedIndex={null}
                          size="M"
                          skin="primary"
                        />
                      </DropdownContainerStyle>
                      {productsFiltered
                        .slice(offset, offset + 10)
                        .map((product) => {
                          let sizes = [];
                          product.fieldSizes.forEach((size) => {
                            sizes.push({
                              label: size.entity.fieldSizeName,
                              value: size.entity.fieldSizeName,
                            });
                          });
                          let currencySign = null;
                          let price = {};
                          if (!currencyById.error && !currencyById.loading) {
                            let currencyName =
                              currencyById.nodeById.fieldCurrencyName;
                            currencySign =
                              currencyById.nodeById.fieldCurrencySign;
                            price = _.find(
                              product.fieldPrices,
                              (price) =>
                                price.entity.fieldCurrency ===
                                (currencyName ? currencyName : "EUR")
                            );
                          }
                          let showAv = this.showAvailability();
                          return (
                            <CardContainer key={product.entityId}>
                              {product.fieldPackageProductsRef.length > 0 ? (
                                <PackageCard
                                  abstract={product.fieldAbstract.value}
                                  availability={
                                    product.fieldAvailability >= 0
                                      ? getTotalByRegion(
                                          product.entityId.toString(),
                                          currentUserQuery.currentUserContext
                                            .fieldRegion,
                                          quantitiesByRegion
                                        )
                                      : 0
                                  }
                                  currency={currencySign}
                                  disableCart={
                                    !price ||
                                    currentUserQuery.currentUserContext.uid ===
                                      0 ||
                                    !product.fieldAvailability ||
                                    !product.fieldMaxShopQuantity
                                  }
                                  handleAddToCart={this.handleAddToCart}
                                  handleGoToDetail={() =>
                                    this.handleGoToDetail(product.entityId)
                                  }
                                  handleOnClickPdf={
                                    product.fieldPdfProduct ||
                                    product.fieldLinkToPdf
                                      ? () =>
                                          this.openPdf(
                                            product.fieldPdfProduct
                                              ? product.fieldPdfProduct.entity
                                                  .url
                                              : product.fieldLinkToPdf.url.path
                                          )
                                      : null
                                  }
                                  id={product.entityId}
                                  lang={
                                    localStorage.getItem("language")
                                      ? localStorage.getItem("language")
                                      : "it"
                                  }
                                  maxQuantity={product.fieldMaxShopQuantity}
                                  name={product.name}
                                  noRegionSelected={
                                    !currentUserQuery.currentUserContext
                                      .fieldRegion
                                  }
                                  price={
                                    price
                                      ? parseFloat(
                                          price.entity.fieldPriceAmount
                                        ).toFixed(2)
                                      : "N/A"
                                  }
                                  photoUrl={
                                    product.fieldProductImages.length > 0
                                      ? product.fieldProductImages[0].url
                                      : ""
                                  }
                                  quantity={1}
                                  showAvailabilityAmount={showAv}
                                  showPrice={
                                    localStorage.getItem("showPrices") ===
                                      "true" &&
                                    !_.find(
                                      currentUserQuery.currentUserContext.roles,
                                      (role) =>
                                        role.targetId === "visitor_customer"
                                    )
                                  }
                                  sizes={sizes}
                                  totProducts={
                                    product.fieldPackageProductsRef.length
                                  }
                                />
                              ) : (
                                <ProductCard
                                  abstract={product.fieldAbstract.value}
                                  availability={
                                    product.fieldAvailability >= 0
                                      ? getTotalByRegion(
                                          product.entityId.toString(),
                                          currentUserQuery.currentUserContext
                                            .fieldRegion,
                                          quantitiesByRegion
                                        )
                                      : 0
                                  }
                                  currency={currencySign}
                                  disableCart={
                                    !price ||
                                    currentUserQuery.currentUserContext.uid ===
                                      0 ||
                                    !product.fieldAvailability ||
                                    !product.fieldMaxShopQuantity
                                  }
                                  handleAddToCart={this.handleAddToCart}
                                  handleGoToDetail={() =>
                                    this.handleGoToDetail(product.entityId)
                                  }
                                  handleOnClickPdf={
                                    product.fieldPdfProduct ||
                                    product.fieldLinkToPdf
                                      ? () =>
                                          this.openPdf(
                                            product.fieldPdfProduct
                                              ? product.fieldPdfProduct.entity
                                                  .url
                                              : product.fieldLinkToPdf.url.path
                                          )
                                      : null
                                  }
                                  id={product.fieldCode}
                                  lang={
                                    localStorage.getItem("language")
                                      ? localStorage.getItem("language")
                                      : "it"
                                  }
                                  maxQuantity={product.fieldMaxShopQuantity}
                                  name={product.name}
                                  noRegionSelected={
                                    !currentUserQuery.currentUserContext
                                      .fieldRegion
                                  }
                                  price={
                                    price
                                      ? parseFloat(
                                          price.entity.fieldPriceAmount
                                        ).toFixed(2)
                                      : "N/A"
                                  }
                                  photoUrl={
                                    product.fieldProductImages.length > 0
                                      ? product.fieldProductImages[0].url
                                      : ""
                                  }
                                  quantity={1}
                                  showAvailabilityAmount={showAv}
                                  showPrice={
                                    localStorage.getItem("showPrices") ===
                                      "true" &&
                                    !_.find(
                                      currentUserQuery.currentUserContext.roles,
                                      (role) =>
                                        role.targetId === "visitor_customer"
                                    )
                                  }
                                  sizes={sizes}
                                />
                              )}
                              {((error && product.fieldCode === errorId) ||
                                (errorQuantity &&
                                  product.fieldCode === errorIdQuantity)) &&
                                this.errorHandler()}
                            </CardContainer>
                          );
                        })}
                      {count > 10 && (
                        <ResponsivePagination
                          currentPage={currentPage}
                          handleNavigateToPage={(props) =>
                            this.fetchMoreProducts(props)
                          }
                          itemsPerPage={ITEMS_PER_PAGE}
                          itemsTotalCount={count}
                        />
                      )}
                    </div>
                  ) : (
                    <div>
                      <Message
                        description={I18n.t("errors.noProductsDescription")}
                        title={I18n.t("errors.noProducts")}
                      />
                    </div>
                  )}
                </ListColStyle>
              </ListRowStyle>
            </div>
          )}
      </GridContainerStyle>
    );
  }
}

export default compose(
  graphql(productSearch, {
    name: "productSearch",
    options: (props) => ({
      variables: {
        name: props.location.state ? props.location.state.name : "",
        page: 0,
        pageSize: 0,
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(childTerms, {
    name: "childTerms",
    options: () => ({
      variables: {
        tid: "29",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(productCategories, {
    name: "productCategories",
    options: () => ({
      variables: {
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(currentUserCart, {
    name: "currentUserCart",
    options: () => ({
      variables: {
        id: localStorage.getItem("currentUid"),
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(createNodeCartLineItem, {
    name: "createNodeCartLineItem",
  }),
  graphql(createNodeCartLineItemWithSizes, {
    name: "createNodeCartLineItemWithSizes",
  }),
  graphql(currentUserQuery, {
    name: "currentUserQuery",
  }),
  graphql(currencyById, {
    name: "currencyById",
    options: () => ({
      variables: {
        id: localStorage.getItem("currency")
          ? localStorage.getItem("currency")
          : localStorage.getItem("defaultCurrency"),
      },
    }),
  })
)(withRouter(withApollo(SearchResultPage)));



// WEBPACK FOOTER //
// ./src/components/searchResults/index.js